<template>
  <div class="row border-row" v-bind:index="'Leg-'+ index+1">
    <div class="small-2 columns">
      <label>&nbsp;</label>
      <h6>
        航段 {{ index+1 }}
        <span class="text-small" v-if="index > 0">
          <a
            data-tooltip
            aria-haspopup="true"
            data-disable-hover="false"
            v-bind:index-id="index"
            class="has-tip top"
            v-on:click="remove"
          >移除</a>
        </span>
      </h6>
    </div>
    <div class="small-10 columns">
      <div class="row">
        <div class="small-12 medium-6 large-6 xlarge-3 columns">
          <label class for="dataLeg0DepartureAirport" :class="{required: depCityHasError}" style="color:#0a2669;text-align:left">
            出发
            <small class="dimmed">城市</small>
          </label>
          <CityInput ref="depCity" v-bind:inputholder="depCityTips"> </CityInput>
        </div>
        <div class="small-12 medium-6 large-6 xlarge-3 columns">
          <label class for="dataLeg0DestinationAirport" :class="{required: arrCityHasError}" style="color:#0a2669;text-align:left">
            到达
            <small class="dimmed">城市</small>
          </label>
          <CityInput ref="arrCity" v-bind:inputholder="arrCityTips"> </CityInput>
        </div>
        <div class="small-12 medium-8 large-8 xlarge-4 columns">
          <div class="row">
            <div class="small-7 xlarge-7 column">
              <label class for="dataLeg0DepartureDate" :class="{required: depDateHasError}" style="color:#0a2669;text-align:left">出发日期</label>
              <DatePicker
                style="width:95%"
                name="depDate"
                v-model="lDepDate"
                type="datetime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :editable="false"
                placeholder="选择日期"
              ></DatePicker>
            </div>
            <div class="small-5 column">
              <label class for="dataLeg0DepartureTime" style="color:#0a2669;text-align:left">出发时间</label>
              <Select v-model="lDepHour">
                <Option  :value="depHour" v-for="depHour in hours" v-bind:key="depHour">{{ depHour }}</Option >
              </Select>
            </div>
          </div>
        </div>
        <div class="small-12 medium-4 large-4 xlarge-2 columns">
          <div class="row">
            <div class="small-6 medium-12 large-12 xlarge-12 columns">
              <label class for="dataLeg0Pax" :class="{required: paxHasError}" style="color:#0a2669;text-align:left">乘客人数</label>
              <Input
                type="number"
                min="1"
                v-model="lPax"
                required
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CityInput from '_c/city-input'
export default {
  name: 'LegItem',
  props: ['index', 'id', 'legKey'],
  components: {
    CityInput
  },
  data () {
    return {
      lDepDate: '',
      lDepHour: '',
      lPax: 0,
      loadedDepData: false,
      dataDepList: [],
      cancelQuery: false,
      hours: this.getHourList(),
      depCityHasError: false,
      arrCityHasError: false,
      depDateHasError: false,
      paxHasError: false,
      depCityTips: 'ZGSZ/深圳',
      arrCityTips: 'ZGAA/北京'
    }
  },
  created () {
    this.lDepHour = '08:00'
  },
  mounted () {
    // console.log(this.leg)
    // this.lDepDate = this.leg.depDate
  },
  methods: {
    getHourList: function () {
      let hours = []
      for (let i = 0; i < 24; i++) {
        if (i < 10) {
          hours.push('0' + i + ':00')
        } else {
          hours.push(i + ':00')
        }
      }
      // console.log(hours)
      return hours
    },
    remove: function () {
      console.log('remove')
      this.$emit('on-remove-leg', { indexId: this.index })
    },
    checkLegValid: function () {
      this.depDateHasError = (this.lDepDate === '')
      this.depCityHasError = (this.$refs.depCity.city === '')
      this.arrCityHasError = (this.$refs.arrCity.city === '')
      this.paxHasError = (this.lPax < 1)
      return (!this.depCityHasError & !this.arrCityHasError & !this.depDateHasError & !this.paxHasError)
    },
    lDepCity: function () {
      return this.$refs.depCity.city
    },
    lArrCity: function () {
      return this.$refs.arrCity.city
    },
    lDepCityCode: function () {
      return this.$refs.depCity.code
    },
    lArrCityCode: function () {
      return this.$refs.arrCity.code
    }
  }
}
</script>
<style scoped>
@import "../assets/styles/app.css";
@import "../assets/elementui/theme-chalk/index.css";
</style>



// WEBPACK FOOTER //
// src/components/leg-item.vue